import type { TabConfig } from 'client/js/main/components/nav/neoTabsConfig';

export const ROI_HUB_PAGE_TITLE = 'ROI Hub';

export const ROI_HUB_NAV_TABS: TabConfig[] = [
  {
    id: 'mui-tab-roi-analytics',
    route: 'analytics',
    label: 'Roi Analytics',
  },
  {
    id: 'mui-tab-connection-overview',
    route: 'connection-overview',
    label: 'Connection Overview',
  },
  {
    id: 'mui-tab-file-ingestion',
    route: 'file-ingestion',
    label: 'File Ingestion',
  },
];
